var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustraliaOzLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 40.862,
    cy: 18.198,
    r: 16.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 41.36,
    cy: 17.522,
    r: 21.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75b34b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#257440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257640"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 71.003,
    cy: 13.22,
    r: 30.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.433,
    y1: 0.512,
    x2: 6.821,
    y2: 0.415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3ab30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#ffed3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -2.653,
    y1: 0.548,
    x2: 3.911,
    y2: 0.452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3ab30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#ffed3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -3.761,
    y1: 0.564,
    x2: 2.803,
    y2: 0.468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3ab30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#ffed3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.867,
    y1: 0.527,
    x2: 3.697,
    y2: 0.437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3ab30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#ffed3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -3.305,
    y1: 0.576,
    x2: 1.26,
    y2: 0.484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3ab30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#ffef3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#ffed3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#ffe73c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ab30"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.929 64.586-7.369.127.076 16.704.875-.013v.507l10.794-.482-.038-2.042a8.57 8.57 0 0 0 5.682 2.169c4.553 0 8.27-3.564 8.549-8.067l.025 7.699 7.356-.076-.101-9.741 3.881-.063.076 9.804h7.306l-.038-6.824c.736 4.021 4.097 7.065 8.561 7.065s8.561-3.856 8.561-8.625a8.65 8.65 0 0 0-3.64-7.065l4.274.038 3.26-12.785-.698-.076.228-1.674c-4.401-.063-8.561-.127-12.988-.469 0 0 1.75-2.346 5.124-6.063C79.071 40.93 90.106 27.08 90.106 27.08l-2.486-.901.736-1.218s-5.91-2.067-15.791-3.551c-9.817-1.497-19.494-.748-19.494-.748l-1.623 8.688c-3.678-6.722-10.781-11.263-19.025-11.263-12.201 0-22.297 9.956-22.526 22.247-.241 12.277 9.474 22.247 21.676 22.247 5.593 0 10.73-2.093 14.7-5.53l-2.067 2.828c5.416 2.055 12.125 3.615 18.949 4.604l-21.625.013-.013 1.877a8.511 8.511 0 0 0-5.581-2.08c-4.731 0-8.561 3.868-8.561 8.625a8.701 8.701 0 0 0 .127 1.522l-1.573-.025v-9.83zM71.5 70.877c.748 0 1.357.824 1.357 1.839s-.609 1.839-1.357 1.839-1.37-.824-1.37-1.839.621-1.839 1.37-1.839zm-35.488.241c.748 0 1.357.824 1.357 1.839s-.609 1.839-1.357 1.839-1.37-.812-1.37-1.839c0-1.015.621-1.839 1.37-1.839zm31.67-6.063a8.79 8.79 0 0 0-1.864 1.306l.013-1.522 1.852.216zM53.351 34.044c1.332 4.883.939 10.121-1.053 14.776 3.424-4.642 6.9-9.246 10.578-13.685l-.076-.469c-3.196-.419-6.266-.596-9.449-.621z",
    fill: "#257440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.548 20.194c11.301 0 20.446 9.208 20.446 20.572s-9.145 20.56-20.446 20.56c-11.288 0-20.446-9.208-20.446-20.56s9.145-20.572 20.446-20.572z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.679 45.485c-4.021-10.058 2.296-17.44 11.884-19.824-2.904 2.461-1.433 5.403 2.067 5.581 3.602.19 6.063-3.945 6.456-7.077 6.697 10.832 8.193 27.079-6.722 30.732 0 .025-1.332-14.015-13.685-9.411z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.431 56.291 3.45-.824-.888-3.678s-1.205 2.625-2.562 4.503z",
    fill: "#257640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.222 32.357 54.2 21.843c5.987-.596 28.094 1.788 31.949 4.059-6.075 8.675-12.848 17.186-19.279 25.773 4.515.774 12.087.837 15.195.824l-2.067 10.324c-7.94.824-26.508-.634-33.497-3.792l19.431-25.963c.013-.013-7.61-.672-13.711-.71z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.108 67.122h4.236l.165 9.589h4.693l.076 4.122h-8.942l-.228-13.711z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.014 66.235 10.033-.241.101 3.97-2.866.076.228 9.703-4.236.101-.317-9.715-2.854.076z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.238 65.918 10.045-.241.089 3.983-2.854.063.216 9.703-4.224.101-.317-9.703-2.854.076z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.051 66.044c4.033 0 7.293 3.285 7.293 7.331 0 4.059-3.26 7.331-7.293 7.331-4.021 0-7.28-3.285-7.28-7.331s3.26-7.331 7.28-7.331zm-.013 4.059c1.56 0 2.828 1.509 2.828 3.374 0 1.852-1.268 3.374-2.828 3.374s-2.828-1.522-2.828-3.374c0-1.877 1.268-3.374 2.828-3.374z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.577 64.916c4.021 0 7.28 3.107 7.28 7.153 0 4.059-3.26 7.331-7.28 7.331-4.033 0-7.293-3.285-7.293-7.331 0-4.059 3.26-7.153 7.293-7.153zm-.013 3.868c1.56 0 2.816 1.509 2.816 3.374s-1.256 3.374-2.816 3.374-2.828-1.509-2.828-3.374 1.268-3.374 2.828-3.374z",
    fill: "url(#h)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaOzLotto);
export default __webpack_public_path__ + "static/media/australia_oz_lotto.fef7b0dc32d1347bd555724ff697e56a.svg";
export { ForwardRef as ReactComponent };